// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `img {
  max-width: 100%;
}

.flex {
  display: flex;
  flex-wrap: wrap;
}

.dir-col {
  flex-direction: column;
}

.dir-col-rev {
  flex-direction: column-reverse;
}

.mh-full {
  min-height: 100%;
}

.mt-auto {
  margin-top: auto;
}

.bt-0 {
  border-top: 0;
}

.bb-0 {
  border-bottom: 0;
}

.fn-body h1,
.fn-body h2,
.fn-body h3,
.fn-body h4,
.fn-body h5,
.fn-body h6 {
  --hGap: 10px;
  font-family: "Museo-700";
  color: #6d6e71;
  margin-bottom: var(--hGap);
  margin-top: 0;
}
.fn-body h1:last-child,
.fn-body h2:last-child,
.fn-body h3:last-child,
.fn-body h4:last-child,
.fn-body h5:last-child,
.fn-body h6:last-child {
  margin-bottom: 0;
}
.fn-body h1,
.fn-body .h1-text {
  font-size: 44px;
  line-height: 1.1;
}
@media only screen and (max-width: 767px) {
  .fn-body h1,
  .fn-body .h1-text {
    font-size: 38px;
  }
}
.fn-body h2,
.fn-body .h2-text {
  font-size: 38px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h2,
  .fn-body .h2-text {
    font-size: 32px;
  }
}
.fn-body h3,
.fn-body .h3-text {
  font-size: 32px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h3,
  .fn-body .h3-text {
    font-size: 24px;
  }
}
.fn-body h4,
.fn-body .h4-text {
  font-size: 24px;
  line-height: 1.2;
}
.fn-body h5,
.fn-body .h5-text {
  font-size: 18px;
  line-height: 1.2;
}
.fn-body h6,
.fn-body .h6-text {
  font-size: 16px;
  line-height: 1.3;
}
.fn-body p {
  font-size: 18px;
  line-height: 1.6;
  color: #6a6a6a;
  margin-top: 0;
  margin-bottom: 10px;
}
.fn-body p:last-child {
  margin-bottom: 0;
}
@media only screen and (max-width: 767px) {
  .fn-body p {
    font-size: 16px;
  }
}
.fn-body ul,
.fn-body ol {
  padding: 0;
  margin: 0;
}
.fn-body sup {
  font-size: 0.7em;
  position: relative;
  top: 5px;
  display: inline-block;
  vertical-align: top;
}

.bg-grey {
  background-color: #eee;
}

.fn-container {
  max-width: 1080px;
  width: calc(100% - 30px);
  margin-inline: auto;
}
@media only screen and (min-width: 992px) {
  .fn-container {
    margin-left: 0;
  }
}
.fn-container--fluid {
  max-width: 1200px;
}
.fn-container--small {
  max-width: 820px;
  width: 100%;
}

.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}

.d-none {
  display: none;
}

.section-title {
  text-align: center;
}
.section-title:not(:last-child) {
  margin-bottom: 40px;
}
.section-title h2:not(:last-child) {
  margin-block-end: 20px;
}
.section-title p {
  max-width: 900px;
  width: 100%;
  margin-inline: auto;
  font-size: 22px;
}
.section-title p:not(:last-child) {
  margin-block-end: 20px;
}
@media only screen and (max-width: 767px) {
  .section-title p {
    font-size: 18px;
  }
}
.section-title .section-title__linkcontainer {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.section-title .section-title__linkcontainer:not(:last-child) {
  margin-block-end: 20px;
}
.section-title .section-title__linkcontainer > * {
  margin: 5px;
}
.section-title .section-title__linkcontainer .fn-btn {
  padding-block: 6px;
  padding-inline: 13px;
  font-size: 12px;
  font-family: "MuseoSans-300";
}

.section-padding {
  padding-block: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding {
    padding-block: 40px;
  }
}
.section-padding-small {
  padding-block: 30px;
}
.section-padding-all {
  padding: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding-all {
    padding: 30px;
  }
}
.section-padding-all-small {
  padding: 30px;
}

.headline {
  --lineSize: 10px;
  width: -moz-fit-content;
  width: fit-content;
  padding-block-end: calc(10px + var(--lineSize));
  margin-inline: auto;
  position: relative;
}
.headline--small-border {
  --lineSize: 6px;
}
.headline:not(:last-child) {
  margin-bottom: calc(var(--hGap) * 2.5);
}
.headline::before {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: var(--lineSize);
  background: linear-gradient(90deg, rgb(0, 173, 208) 0%, rgb(0, 173, 208) 25%, rgb(255, 121, 0) 25%, rgb(255, 121, 0) 50%, rgb(105, 190, 40) 50%, rgb(105, 190, 40) 75%, rgb(245, 67, 89) 75%, rgb(245, 67, 89) 100%);
}

.custom-list li {
  font-size: 18px;
  line-height: 1.4;
  color: #6a6a6a;
  list-style: none;
  position: relative;
  padding-left: 15px;
}
.custom-list li:not(:last-child) {
  margin-bottom: 4px;
}
.custom-list li::before {
  content: "";
  position: absolute;
  top: 10px;
  left: 0;
  width: 3px;
  height: 3px;
  background-color: var(--clrProfile);
}

.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.fn-btn {
  padding-block: 20px;
  padding-inline: 28px;
  background-color: rgb(105, 190, 40);
  color: #fff;
  font-size: 18px;
  line-height: 1.2;
  display: inline-block;
  font-family: "Museo-700";
  text-decoration: none;
  word-break: break-all;
  text-align: center;
  transition: background-color 0.3s;
}
.fn-btn:focus {
  outline: 1px dashed #6a6a6a;
  outline-offset: 4px;
}
.fn-btn:hover {
  background-color: #6d6e71;
  color: #fff;
}
.fn-btn--sm {
  font-size: 14px;
  padding-block: 10px;
  padding-inline: 20px;
}
.fn-btn--grey {
  background-color: #f1f1f2;
  color: #6d6e71;
}
.fn-btn--ongoing {
  background-color: #f8ac59;
  color: #fff;
}
.fn-btn--ongoing i {
  animation: spin 0.3s infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.w-4 {
  width: 33.3333333333%;
}

.w-3 {
  width: 25%;
}
.w-3--wd {
  width: 33.3333333333%;
}

.w-6 {
  width: 50%;
}

.fn-row {
  --rGap: 15px;
  --rGap-minus: calc(-1 * var(--rGap));
  display: flex;
  flex-wrap: wrap;
  margin-inline: var(--rGap-minus);
}
.fn-row--col-gap-exist .fn-col {
  margin-bottom: 30px;
}
.fn-col {
  padding-inline: var(--rGap);
}
.fn-justify-center {
  justify-content: center;
}
.fn-items-center {
  align-items: center;
}

.mx-auto {
  margin-inline: auto;
}
.ml-auto {
  margin-inline-start: auto;
}
.ml-0 {
  margin-inline-start: 0;
}
.mr-auto {
  margin-inline-end: auto;
}
.mr-0 {
  margin-inline-end: 0;
}

.ps-page {
  min-height: 100vh;
  background-color: #f7f8fa;
  padding: 40px 0 60px;
}
@media (max-width: 767px) {
  .ps-page {
    padding: 24px 0 40px;
  }
}

.ps-container {
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 24px;
}
@media (max-width: 767px) {
  .ps-container {
    padding: 0 16px;
  }
}

.ps-error {
  background-color: #fee2e2;
  border: 1px solid #fca5a5;
  border-radius: 10px;
  padding: 24px 32px;
  margin-bottom: 24px;
}
.ps-error h1 {
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 22px;
  font-weight: 700;
  color: #b91c1c;
  margin: 0 0 8px;
}
.ps-error h2 {
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 16px;
  font-weight: 600;
  color: #991b1b;
  margin: 0 0 12px;
}
.ps-error p {
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 14px;
  color: #7f1d1d;
  margin: 0 0 4px;
  line-height: 1.5;
}

.ps-header {
  margin-bottom: 32px;
}
.ps-header__title {
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 32px;
  font-weight: 700;
  color: #6d6e71;
  margin: 0 0 8px;
  letter-spacing: -0.5px;
}
@media (max-width: 767px) {
  .ps-header__title {
    font-size: 26px;
  }
}

.ps-breadcrumb {
  display: flex;
  align-items: center;
  gap: 8px;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 13px;
  color: #676a6c;
}
.ps-breadcrumb a {
  color: #676a6c;
  text-decoration: none;
  transition: color 0.2s;
}
.ps-breadcrumb a:hover {
  color: rgb(105, 190, 40);
}
.ps-breadcrumb__separator {
  color: #ccc;
}

.ps-toolbar {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 28px;
  padding: 12px 16px;
  background: #fff;
  border-radius: 10px;
  border: 1px solid #e7eaec;
}
@media (max-width: 767px) {
  .ps-toolbar {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
  }
}
.ps-toolbar__filter--search {
  flex: 1;
}
.ps-toolbar__search-wrap {
  position: relative;
  display: flex;
  align-items: center;
}
.ps-toolbar__search-icon {
  position: absolute;
  left: 12px;
  color: #ccc;
  font-size: 13px;
  pointer-events: none;
}
.ps-toolbar__input {
  width: 100%;
  padding: 9px 36px 9px 34px;
  border: 1px solid #e7eaec;
  border-radius: 6px;
  font-size: 13px;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  color: #6d6e71;
  background: #f8f9fa;
  outline: none;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}
.ps-toolbar__input::placeholder {
  color: #ccc;
}
.ps-toolbar__input:focus {
  border-color: rgb(105, 190, 40);
  box-shadow: 0 0 0 2px rgba(105, 190, 40, 0.12);
  background: #fff;
}
.ps-toolbar__clear {
  position: absolute;
  right: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border: none;
  background: none;
  color: #ccc;
  cursor: pointer;
  font-size: 14px;
  border-radius: 4px;
  transition: all 0.15s ease;
}
.ps-toolbar__clear:hover {
  color: #b91c1c;
  background: rgba(185, 28, 28, 0.06);
}
.ps-toolbar__select {
  padding: 9px 12px;
  border: 1px solid #e7eaec;
  border-radius: 6px;
  font-size: 13px;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  color: #6d6e71;
  background: #f8f9fa;
  outline: none;
  appearance: auto;
  cursor: pointer;
  transition: border-color 0.2s ease;
}
.ps-toolbar__select:focus {
  border-color: rgb(105, 190, 40);
}
@media (max-width: 767px) {
  .ps-toolbar__select {
    width: 100%;
  }
}
.ps-toolbar__count {
  font-size: 13px;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-weight: 600;
  color: #676a6c;
  white-space: nowrap;
}
@media (max-width: 767px) {
  .ps-toolbar__count {
    text-align: center;
  }
}

.ps-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  text-align: center;
}
.ps-empty > i {
  font-size: 36px;
  margin-bottom: 16px;
  color: #ccc;
}
.ps-empty p {
  font-size: 15px;
  color: #676a6c;
  margin: 0 0 16px;
}

.ps-category {
  margin-bottom: 40px;
}
.ps-category[hidden] {
  display: none !important;
}
.ps-category__title {
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 24px;
  font-weight: 700;
  color: #6d6e71;
  margin: 0 0 20px;
  padding-bottom: 12px;
  border-bottom: 2px solid #e7eaec;
}
.ps-category__title:empty {
  display: none;
}

.ps-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 24px;
}
@media (max-width: 640px) {
  .ps-grid {
    grid-template-columns: 1fr;
    gap: 16px;
  }
}

.ps-card {
  background: #fff;
  border-radius: 10px;
  border: 1px solid #e7eaec;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  transition: box-shadow 0.25s ease, transform 0.25s ease;
}
.ps-card[hidden] {
  display: none !important;
}
.ps-card:hover {
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
  transform: translateY(-3px);
}
.ps-card__image-link {
  display: block;
  text-decoration: none;
  overflow: hidden;
}
.ps-card__image {
  width: 100%;
  aspect-ratio: 4/5;
  overflow: hidden;
  background: #f8f9fa;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px;
}
.ps-card__image img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  transition: transform 0.35s ease;
}
.ps-card__image:hover img {
  transform: scale(1.04);
}
.ps-card__body {
  padding: 14px 16px 16px;
  display: flex;
  flex-direction: column;
  flex: 1;
}
.ps-card__name {
  margin-bottom: 4px;
}
.ps-card__name-link {
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: #6d6e71;
  text-decoration: none;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.35;
  transition: color 0.2s;
}
.ps-card__name-link:hover {
  color: rgb(105, 190, 40);
}
.ps-card__price {
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 16px;
  font-weight: 700;
  color: rgb(105, 190, 40);
  display: block;
  margin-bottom: 10px;
}
.ps-card__actions {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: auto;
}
.ps-card__qty {
  flex-shrink: 0;
}
.ps-card__qty-input {
  width: 56px;
  height: 32px;
  border: 1px solid #e7eaec;
  border-radius: 5px;
  padding: 2px 4px;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 13px;
  text-align: center;
  color: #6d6e71;
  background: #fff;
  outline: none;
  transition: border-color 0.2s;
}
.ps-card__qty-input::-webkit-inner-spin-button, .ps-card__qty-input::-webkit-outer-spin-button {
  opacity: 1;
  height: 24px;
}
.ps-card__qty-input:focus {
  border-color: rgb(105, 190, 40);
  box-shadow: 0 0 0 2px rgba(105, 190, 40, 0.12);
}
.ps-card__btn-group {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
}

.ps-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 5px 12px;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 12px;
  font-weight: 600;
  border-radius: 5px;
  cursor: pointer;
  text-decoration: none;
  transition: all 0.2s ease;
  white-space: nowrap;
  line-height: 1.4;
  border: 1.5px solid transparent;
}
.ps-btn--filled-green {
  background-color: rgb(105, 190, 40);
  color: #fff;
  border-color: rgb(105, 190, 40);
}
.ps-btn--filled-green:hover {
  background-color: #569c21;
  border-color: #569c21;
  color: #fff;
  text-decoration: none;
}
.ps-btn--outline-green {
  background: transparent;
  color: rgb(105, 190, 40);
  border-color: rgb(105, 190, 40);
}
.ps-btn--outline-green:hover {
  background-color: rgb(105, 190, 40);
  color: #fff;
  text-decoration: none;
}
.ps-btn--outline-cyan {
  background: transparent;
  color: rgb(0, 173, 208);
  border-color: rgb(0, 173, 208);
}
.ps-btn--outline-cyan:hover {
  background-color: rgb(0, 173, 208);
  color: #fff;
  text-decoration: none;
}

.ps-loader {
  width: 100%;
  padding: 60px 0;
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/_variables.scss","webpack://./src/app/components/store/public-store/public-store-products/public-store-products.component.scss"],"names":[],"mappings":"AAgIA;EACE,eAAA;AC/HF;;ADkIA;EACE,aAAA;EACA,eAAA;AC/HF;;ADkIA;EACE,sBAAA;AC/HF;;ADkIA;EACE,8BAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;ADkIA;EACE,aAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;AD6IE;;;;;;EAME,YAAA;EACA,wBA7KO;EA8KP,cA3IiB;EA4IjB,0BAAA;EACA,aAAA;AC1IJ;AD4II;;;;;;EACE,gBAAA;ACrIN;ADyIE;;EAEE,eA5GO;EA6GP,gBA3GO;AC5BX;ADyII;EALF;;IAMI,eA/GY;ECtBhB;AACF;ADwIE;;EAEE,eAlHO;EAmHP,gBAjHO;ACrBX;ADwII;EALF;;IAMI,eArHY;ECfhB;AACF;ADuIE;;EAEE,eAxHO;EAyHP,gBAvHO;ACdX;ADuII;EALF;;IAMI,eA3HY;ECRhB;AACF;ADsIE;;EAEE,eA9HO;EA+HP,gBA7HO;ACPX;ADuIE;;EAEE,eAhIO;EAiIP,gBAhIO;ACLX;ADwIE;;EAEE,eAnIO;EAoIP,gBAnIO;ACHX;AD4IE;EACE,eAAA;EACA,gBAAA;EACA,cAzMqB;EA0MrB,aAAA;EACA,mBAAA;AC1IJ;AD4II;EACE,gBAAA;AC1IN;AD6II;EAXF;IAYI,eAAA;EC1IJ;AACF;AD6IE;;EAEE,UAAA;EACA,SAAA;AC3IJ;AD8IE;EACE,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,qBAAA;EACA,mBAAA;AC5IJ;;ADgJA;EACE,sBAxNQ;AC2EV;;ADgJA;EACE,iBAlKU;EAmKV,wBAAA;EACA,mBAAA;AC7IF;AD+IE;EALF;IAMI,cAAA;EC5IF;AACF;AD8IE;EACE,iBA1Ka;AC8BjB;AD+IE;EACE,gBApLa;EAqLb,WAAA;AC7IJ;;ADkJE;EACE,kBAAA;AC/IJ;ADkJE;EACE,iBAAA;AChJJ;;ADqJE;EACE,aAAA;AClJJ;;ADsJA;EACE,kBAAA;ACnJF;ADqJE;EACE,mBAAA;ACnJJ;ADuJI;EACE,sBAAA;ACrJN;ADyJE;EACE,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,eA9Ne;ACuEnB;ADyJI;EACE,sBAAA;ACvJN;AD0JI;EAVF;IAWI,eApOoB;EC6ExB;AACF;AD0JE;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;ACxJJ;AD0JI;EACE,sBAAA;ACxJN;AD2JI;EACE,WAAA;ACzJN;AD4JI;EACE,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,4BA5VM;ACkMZ;;AD+JA;EACE,mBA1PO;AC8FT;AD8JE;EAHF;IAII,mBAAA;EC3JF;AACF;AD6JE;EACE,mBAAA;AC3JJ;AD8JE;EACE,aArQK;ACyGT;AD8JI;EAHF;IAII,aAAA;EC3JJ;AACF;AD6JI;EACE,aAAA;AC3JN;;ADgKA;EACE,gBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,+CAAA;EACA,mBAAA;EACA,kBAAA;AC7JF;AD+JE;EACE,eAAA;AC7JJ;ADgKE;EACE,sCAAA;AC9JJ;ADiKE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,uBAAA;EACA,oNAAA;AC/JJ;;AD8KE;EACE,eAAA;EACA,gBAAA;EACA,cA/XqB;EAgYrB,gBAAA;EACA,kBAAA;EACA,kBAAA;AC3KJ;AD6KI;EACE,kBAAA;AC3KN;AD8KI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,mCAAA;AC5KN;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,+BAAA;AC9KF;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,mBAAA;EACA,oBAAA;EACA,mCAzbc;EA0bd,WAzZS;EA0ZT,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,wBAhdS;EAidT,qBAAA;EACA,qBAAA;EACA,kBAAA;EACA,iCAAA;AC9KF;ADgLE;EACE,2BAAA;EACA,mBAAA;AC9KJ;ADiLE;EACE,yBAzbiB;EA0bjB,WA1aO;AC2PX;ADkLE;EACE,eAAA;EACA,mBAAA;EACA,oBAAA;AChLJ;ADmLE;EACE,yBAjckB;EAkclB,cArciB;ACoRrB;ADoLE;EACE,yBAvbS;EAwbT,WA1bO;ACwQX;ADoLI;EACE,6BAAA;AClLN;;ADuLA;EACE;IACE,uBAAA;ECpLF;EDuLA;IACE,yBAAA;ECrLF;AACF;ADwLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,+BAAA;ACtLF;;ADyLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,qBAAA;ACtLF;;ADyLA;EACE,UAAA;ACtLF;ADwLE;EACE,qBAAA;ACtLJ;;AD0LA;EACE,UAAA;ACvLF;;AD2LE;EACE,YAAA;EACA,oCAAA;EAEA,aAAA;EACA,eAAA;EACA,gCAAA;ACzLJ;AD4LM;EACE,mBAAA;AC1LR;AD+LE;EACE,2BAAA;AC7LJ;ADgME;EACE,uBAAA;AC9LJ;ADiME;EACE,mBAAA;AC/LJ;;ADoME;EACE,mBAAA;ACjMJ;ADoME;EACE,yBAAA;AClMJ;ADqME;EACE,sBAAA;ACnMJ;ADsME;EACE,uBAAA;ACpMJ;ADuME;EACE,oBAAA;ACrMJ;;AA5YA;EACE,iBAAA;EACA,yBAAA;EACA,oBAAA;AA+YF;AA7YE;EALF;IAMI,oBAAA;EAgZF;AACF;;AA7YA;EACE,iBAAA;EACA,cAAA;EACA,eAAA;AAgZF;AA9YE;EALF;IAMI,eAAA;EAiZF;AACF;;AA7YA;EACE,yBAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;AAgZF;AA9YE;EACE,wED/BS;ECgCT,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;AAgZJ;AA7YE;EACE,wEDvCS;ECwCT,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AA+YJ;AA5YE;EACE,wED/CS;ECgDT,eAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AA8YJ;;AAzYA;EACE,mBAAA;AA4YF;AA1YE;EACE,wED5DS;EC6DT,eAAA;EACA,gBAAA;EACA,cDvBiB;ECwBjB,eAAA;EACA,sBAAA;AA4YJ;AA1YI;EARF;IASI,eAAA;EA6YJ;AACF;;AAzYA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,wED7EW;EC8EX,eAAA;EACA,cD5CmB;ACwbrB;AA1YE;EACE,cD/CiB;ECgDjB,qBAAA;EACA,sBAAA;AA4YJ;AA1YI;EACE,wBDhEU;AC4chB;AAxYE;EACE,WDlDgB;AC4bpB;;AArYA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;AAwYF;AAtYE;EAVF;IAWI,sBAAA;IACA,oBAAA;IACA,SAAA;EAyYF;AACF;AAtYI;EACE,OAAA;AAwYN;AApYE;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;AAsYJ;AAnYE;EACE,kBAAA;EACA,UAAA;EACA,WDtFgB;ECuFhB,eAAA;EACA,oBAAA;AAqYJ;AAlYE;EACE,WAAA;EACA,0BAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,wED3IS;EC4IT,cDpGiB;ECqGjB,mBAAA;EACA,aAAA;EACA,wDAAA;AAoYJ;AAlYI;EAAiB,WDvGD;AC4epB;AAnYI;EACE,+BD7HU;EC8HV,8CAAA;EACA,gBAAA;AAqYN;AAjYE;EACE,kBAAA;EACA,UAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,WD1HgB;EC2HhB,eAAA;EACA,eAAA;EACA,kBAAA;EACA,0BAAA;AAmYJ;AAjYI;EACE,cAAA;EACA,mCAAA;AAmYN;AA/XE;EACE,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,wEDrLS;ECsLT,cD9IiB;EC+IjB,mBAAA;EACA,aAAA;EACA,gBAAA;EACA,eAAA;EACA,kCAAA;AAiYJ;AA/XI;EACE,+BDvKU;ACwiBhB;AA9XI;EAjBF;IAkBI,WAAA;EAiYJ;AACF;AA9XE;EACE,eAAA;EACA,wEDxMS;ECyMT,gBAAA;EACA,cDvKiB;ECwKjB,mBAAA;AAgYJ;AA9XI;EAPF;IAQI,kBAAA;EAiYJ;AACF;;AA5XA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,kBAAA;AA+XF;AA7XE;EACE,eAAA;EACA,mBAAA;EACA,WDrLgB;ACojBpB;AA5XE;EACE,eAAA;EACA,cDjMiB;ECkMjB,gBAAA;AA8XJ;;AAzXA;EACE,mBAAA;AA4XF;AA1XE;EAAY,wBAAA;AA6Xd;AA3XE;EACE,wEDhPS;ECiPT,eAAA;EACA,gBAAA;EACA,cD3MiB;EC4MjB,gBAAA;EACA,oBAAA;EACA,gCAAA;AA6XJ;AA3XI;EACE,aAAA;AA6XN;;AAvXA;EACE,aAAA;EACA,4DAAA;EACA,SAAA;AA0XF;AAxXE;EALF;IAMI,0BAAA;IACA,SAAA;EA2XF;AACF;;AAvXA;EACE,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EAGA,uDAAA;AAwXF;AAzXE;EAAY,wBAAA;AA4Xd;AAzXE;EACE,0CAAA;EACA,2BAAA;AA2XJ;AAvXE;EACE,cAAA;EACA,qBAAA;EACA,gBAAA;AAyXJ;AAtXE;EACE,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;AAwXJ;AAtXI;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,gCAAA;AAwXN;AArXI;EACE,sBAAA;AAuXN;AAlXE;EACE,uBAAA;EACA,aAAA;EACA,sBAAA;EACA,OAAA;AAoXJ;AAhXE;EACE,kBAAA;AAkXJ;AA/WE;EACE,wEDtUS;ECuUT,eAAA;EACA,gBAAA;EACA,cDjSiB;ECkSjB,qBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;EACA,iBAAA;EACA,sBAAA;AAiXJ;AA/WI;EACE,wBD7TU;AC8qBhB;AA5WE;EACE,wED1VS;EC2VT,eAAA;EACA,gBAAA;EACA,wBDtUY;ECuUZ,cAAA;EACA,mBAAA;AA8WJ;AA1WE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;AA4WJ;AAxWE;EACE,cAAA;AA0WJ;AAvWE;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,wEDrXS;ECsXT,eAAA;EACA,kBAAA;EACA,cDhViB;ECiVjB,gBAAA;EACA,aAAA;EACA,6BAAA;AAyWJ;AAtWI;EAEE,UAAA;EACA,YAAA;AAuWN;AApWI;EACE,+BD9WU;EC+WV,8CAAA;AAsWN;AAjWE;EACE,aAAA;EACA,QAAA;EACA,eAAA;AAmWJ;;AA9VA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,wEDxZW;ECyZX,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,qBAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,+BAAA;AAiWF;AA/VE;EACE,mCD7YY;EC8YZ,WAAA;EACA,+BD/YY;ACgvBhB;AA/VI;EACE,yBAAA;EACA,qBAAA;EACA,WAAA;EACA,qBAAA;AAiWN;AA7VE;EACE,uBAAA;EACA,wBD3ZY;EC4ZZ,+BD5ZY;AC2vBhB;AA7VI;EACE,mCD/ZU;ECgaV,WAAA;EACA,qBAAA;AA+VN;AA3VE;EACE,uBAAA;EACA,uBDzaY;EC0aZ,8BD1aY;ACuwBhB;AA3VI;EACE,kCD7aU;EC8aV,WAAA;EACA,qBAAA;AA6VN;;AAvVA;EACE,WAAA;EACA,eAAA;EACA,kBAAA;AA0VF","sourcesContent":["// Font\n$font-stack: \"open sans\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n$muso-100: \"Museo-100\";\n$muso-300: \"Museo-300\";\n$muso-300-i: \"Museo-300Italic\";\n$muso-500: \"Museo-regular\";\n$muso-700: \"Museo-700\";\n$muso-700-i: \"Museo-700Italic\";\n$muso-sans: \"MuseoSans-300\";\n$car-font: \"Marydale\";\n$car-big-font: \"Bangers\", cursive;\n$font-museo: \"Conv_museo-500-webfont\";\n$font-helvetica: \"Helvetica\", \"open sans\";\n$MuseoSansCondensed-300: \"MuseoSansCondensed-300\";\n\n$fwBold: 700;\n\n//Foursight\n// $clarify-color: #06A6CE;\n// $ideate-color: #FF8300;\n// $develop-color: #7BBC43;\n// $implement-color: #FF485C;\n$clarify-color: rgba(0, 173, 208, 1);\n$ideate-color: rgba(255, 121, 0, 1);\n$develop-color: rgba(105, 190, 40, 1);\n$implement-color: rgba(245, 67, 89, 1);\n$low-clarify-color: rgba(0, 173, 208, 1);\n$low-ideate-color: rgba(255, 121, 0, 1);\n$low-develop-color: rgba(105, 190, 40, 1);\n$low-implement-color: rgba(245, 67, 89, 1);\n$profile-connector-color: #656668;\n// Profile Neutral color\n$integrator-color: #e3e3e3;\n// Team Report\n$report-integrator: #a7a7a7;\n// Body text color in reports\n$body-content-color: #676a6c;\n// Learner Map\n$gray-lm: rgba(0, 0, 0, 0.2);\n$border-color: #aaa;\n\n$color-neutral-dark: #6d6e71;\n$color-neutral-dark-500: #6a6a6a;\n$color-neutral-mid: #ccc;\n$color-neutral-light: #f1f1f2;\n$color-neutral-mid-old: #9e9e97;\n$color-dark-green: #4cae4c;\n$color-light-grey: #d9d9d9;\n$color-red: #ff485c;\n\n$color-grey-1: #e7eaec;\n\n$clrGray1: #f6f6f6;\n\n$clrDarkGray1: #ddd;\n\n$clrGrey: #eee;\n$clrWhite: #fff;\n$clrBlack: #000;\n$clrWarning: #f8ac59;\n\n$assets: \"https://assets.foursightonline.com/app\";\n$adminUpload: \"https://assets.foursightonline.com/admin-uploads/docs/\";\n\n$separator: \"\\//\";\n\n$active-class: #017ebc;\n\n// anchor Tag\n$anchor-color: #337ab7;\n\n//Sidebar\n$color-light-type: #fff;\n// submenu background\n$fs-dark-grey: #464646;\n// Hover\n$fs-active-light: #5f5f63;\n$fs-sidenav-bg: #333333;\n$fs-sidenav-hov-bg: #3e3e3f;\n$fs-green: #69be28;\n\n$clrInputAccent: #639935;\n\n$fn-fs-h1: 44px;\n$fn-fs-h1-mobile: 38px;\n$fn-lh-h1: 1.1;\n\n$fn-fs-h2: 38px;\n$fn-fs-h2-mobile: 32px;\n$fn-lh-h2: 1.2;\n\n$fn-fs-h3: 32px;\n$fn-fs-h3-mobile: 24px;\n$fn-lh-h3: 1.2;\n\n$fn-fs-h4: 24px;\n$fn-fs-h4-mobile: 20px;\n$fn-lh-h4: 1.2;\n\n$fn-fs-h5: 18px;\n$fn-lh-h5: 1.2;\n\n$fn-fs-h6: 16px;\n$fn-lh-h6: 1.3;\n\n$fn-title-subtext: 22px;\n$fn-title-subtext-mobile: 18px;\n\n$pageWidth: 1080px;\n$pageWidthSmall: 820px;\n$pageWidthFluid: 1200px;\n\n$secPad: 60px;\n\n$pageWidth: 1080px;\n$pageWidthFluid: 1200px;\n\n$desktop: \"only screen and (max-width: 1600px)\";\n$mac: \"only screen and (max-width: 1350px)\";\n$pc-up: \"only screen and (min-width: 1200px)\";\n$pc: \"only screen and (max-width: 1199px)\";\n$tablet-up: \"only screen and (min-width: 992px)\";\n$tablet: \"only screen and (max-width: 991px)\";\n$mobile-up: \"only screen and (min-width: 768px)\";\n$mobile: \"only screen and (max-width: 767px)\";\n$xl: \"only screen and (max-width: 1440px)\";\n$xl-up: \"only screen and (min-width: 1440px)\";\n\nimg {\n  max-width: 100%;\n}\n\n.flex {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.dir-col {\n  flex-direction: column;\n}\n\n.dir-col-rev {\n  flex-direction: column-reverse;\n}\n\n.mh-full {\n  min-height: 100%;\n}\n\n.mt-auto {\n  margin-top: auto;\n}\n\n.bt-0 {\n  border-top: 0;\n}\n\n.bb-0 {\n  border-bottom: 0;\n}\n\n@mixin headingfont() {\n  font-family: $muso-700 !important;\n  font-weight: normal !important;\n}\n\n@mixin contentfont() {\n  font-family: $muso-300 !important;\n  font-weight: normal !important;\n}\n\n.fn-body {\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    --hGap: 10px;\n    font-family: $muso-700;\n    color: $color-neutral-dark;\n    margin-bottom: var(--hGap);\n    margin-top: 0;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n\n  h1,\n  .h1-text {\n    font-size: $fn-fs-h1;\n    line-height: $fn-lh-h1;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h1-mobile;\n    }\n  }\n\n  h2,\n  .h2-text {\n    font-size: $fn-fs-h2;\n    line-height: $fn-lh-h2;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h2-mobile;\n    }\n  }\n\n  h3,\n  .h3-text {\n    font-size: $fn-fs-h3;\n    line-height: $fn-lh-h3;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h3-mobile;\n    }\n  }\n\n  h4,\n  .h4-text {\n    font-size: $fn-fs-h4;\n    line-height: $fn-lh-h4;\n  }\n\n  h5,\n  .h5-text {\n    font-size: $fn-fs-h5;\n    line-height: $fn-lh-h5;\n  }\n\n  h6,\n  .h6-text {\n    font-size: $fn-fs-h6;\n    line-height: $fn-lh-h6;\n  }\n\n  $fn-title-subtext: 22px;\n  $fn-title-subtext-mobile: 18px;\n\n  p {\n    font-size: 18px;\n    line-height: 1.6;\n    color: $color-neutral-dark-500;\n    margin-top: 0;\n    margin-bottom: 10px;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n\n    @media #{$mobile} {\n      font-size: 16px;\n    }\n  }\n\n  ul,\n  ol {\n    padding: 0;\n    margin: 0;\n  }\n\n  sup {\n    font-size: 0.7em;\n    position: relative;\n    top: 5px;\n    display: inline-block;\n    vertical-align: top;\n  }\n}\n\n.bg-grey {\n  background-color: $clrGrey;\n}\n\n.fn-container {\n  max-width: $pageWidth;\n  width: calc(100% - 30px);\n  margin-inline: auto;\n\n  @media #{$tablet-up} {\n    margin-left: 0;\n  }\n\n  &--fluid {\n    max-width: $pageWidthFluid;\n  }\n\n  &--small {\n    max-width: $pageWidthSmall;\n    width: 100%;\n  }\n}\n\n.text {\n  &-center {\n    text-align: center;\n  }\n\n  &-right {\n    text-align: right;\n  }\n}\n\n.d {\n  &-none {\n    display: none;\n  }\n}\n\n.section-title {\n  text-align: center;\n\n  &:not(:last-child) {\n    margin-bottom: calc($secPad - 20px);\n  }\n\n  h2 {\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n  }\n\n  p {\n    max-width: 900px;\n    width: 100%;\n    margin-inline: auto;\n    font-size: $fn-title-subtext;\n\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n\n    @media #{$mobile} {\n      font-size: $fn-title-subtext-mobile;\n    }\n  }\n\n  .section-title__linkcontainer {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: center;\n\n    &:not(:last-child) {\n      margin-block-end: 20px;\n    }\n\n    & > * {\n      margin: 5px;\n    }\n\n    .fn-btn {\n      padding-block: 6px;\n      padding-inline: 13px;\n      font-size: 12px;\n      font-family: $muso-sans;\n    }\n  }\n}\n\n.section-padding {\n  padding-block: $secPad;\n\n  @media #{$mobile} {\n    padding-block: ($secPad - 20px);\n  }\n\n  &-small {\n    padding-block: calc($secPad / 2);\n  }\n\n  &-all {\n    padding: $secPad;\n\n    @media #{$mobile} {\n      padding: calc($secPad / 2);\n    }\n\n    &-small {\n      padding: calc($secPad / 2);\n    }\n  }\n}\n\n.headline {\n  --lineSize: 10px;\n  width: fit-content;\n  padding-block-end: calc(10px + var(--lineSize));\n  margin-inline: auto;\n  position: relative;\n\n  &--small-border {\n    --lineSize: 6px;\n  }\n\n  &:not(:last-child) {\n    margin-bottom: calc(var(--hGap) * 2.5);\n  }\n\n  &::before {\n    content: \"\";\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: var(--lineSize);\n    background: linear-gradient(\n      90deg,\n      $clarify-color 0%,\n      $clarify-color 25%,\n      $ideate-color 25%,\n      $ideate-color 50%,\n      $develop-color 50%,\n      $develop-color 75%,\n      $implement-color 75%,\n      $implement-color 100%\n    );\n  }\n}\n\n.custom-list {\n  li {\n    font-size: 18px;\n    line-height: 1.4;\n    color: $color-neutral-dark-500;\n    list-style: none;\n    position: relative;\n    padding-left: 15px;\n\n    &:not(:last-child) {\n      margin-bottom: 4px;\n    }\n\n    &::before {\n      content: \"\";\n      position: absolute;\n      top: 10px;\n      left: 0;\n      width: 3px;\n      height: 3px;\n      background-color: var(--clrProfile);\n    }\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.fn-btn {\n  padding-block: 20px;\n  padding-inline: 28px;\n  background-color: $develop-color;\n  color: $clrWhite;\n  font-size: 18px;\n  line-height: 1.2;\n  display: inline-block;\n  font-family: $muso-700;\n  text-decoration: none;\n  word-break: break-all;\n  text-align: center;\n  transition: background-color 0.3s;\n\n  &:focus {\n    outline: 1px dashed $color-neutral-dark-500;\n    outline-offset: 4px;\n  }\n\n  &:hover {\n    background-color: $color-neutral-dark;\n    color: $clrWhite;\n  }\n\n  &--sm {\n    font-size: 14px;\n    padding-block: 10px;\n    padding-inline: 20px;\n  }\n\n  &--grey {\n    background-color: $color-neutral-light;\n    color: $color-neutral-dark;\n  }\n\n  &--ongoing {\n    background-color: $clrWarning;\n    color: $clrWhite;\n\n    i {\n      animation: spin 0.3s infinite;\n    }\n  }\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.w-4 {\n  width: calc(100% / 3);\n}\n\n.w-3 {\n  width: calc(100% / 4);\n\n  &--wd {\n    width: calc(100% / 3);\n  }\n}\n\n.w-6 {\n  width: calc(100% / 2);\n}\n\n.fn {\n  &-row {\n    --rGap: 15px;\n    --rGap-minus: calc(-1 * var(--rGap));\n\n    display: flex;\n    flex-wrap: wrap;\n    margin-inline: var(--rGap-minus);\n\n    &--col-gap-exist {\n      .fn-col {\n        margin-bottom: calc($secPad / 2);\n      }\n    }\n  }\n\n  &-col {\n    padding-inline: var(--rGap);\n  }\n\n  &-justify-center {\n    justify-content: center;\n  }\n\n  &-items-center {\n    align-items: center;\n  }\n}\n\n.m {\n  &x-auto {\n    margin-inline: auto;\n  }\n\n  &l-auto {\n    margin-inline-start: auto;\n  }\n\n  &l-0 {\n    margin-inline-start: 0;\n  }\n\n  &r-auto {\n    margin-inline-end: auto;\n  }\n\n  &r-0 {\n    margin-inline-end: 0;\n  }\n}\n","@import './../../../../../assets/styles/variables';\n\n// ── Page Layout ──────────────────────────────────────────────\n.ps-page {\n  min-height: 100vh;\n  background-color: #f7f8fa;\n  padding: 40px 0 60px;\n\n  @media (max-width: 767px) {\n    padding: 24px 0 40px;\n  }\n}\n\n.ps-container {\n  max-width: 1280px;\n  margin: 0 auto;\n  padding: 0 24px;\n\n  @media (max-width: 767px) {\n    padding: 0 16px;\n  }\n}\n\n// ── Error State ──────────────────────────────────────────────\n.ps-error {\n  background-color: #fee2e2;\n  border: 1px solid #fca5a5;\n  border-radius: 10px;\n  padding: 24px 32px;\n  margin-bottom: 24px;\n\n  h1 {\n    font-family: $font-stack;\n    font-size: 22px;\n    font-weight: 700;\n    color: #b91c1c;\n    margin: 0 0 8px;\n  }\n\n  h2 {\n    font-family: $font-stack;\n    font-size: 16px;\n    font-weight: 600;\n    color: #991b1b;\n    margin: 0 0 12px;\n  }\n\n  p {\n    font-family: $font-stack;\n    font-size: 14px;\n    color: #7f1d1d;\n    margin: 0 0 4px;\n    line-height: 1.5;\n  }\n}\n\n// ── Page Header ──────────────────────────────────────────────\n.ps-header {\n  margin-bottom: 32px;\n\n  &__title {\n    font-family: $font-stack;\n    font-size: 32px;\n    font-weight: 700;\n    color: $color-neutral-dark;\n    margin: 0 0 8px;\n    letter-spacing: -0.5px;\n\n    @media (max-width: 767px) {\n      font-size: 26px;\n    }\n  }\n}\n\n.ps-breadcrumb {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-family: $font-stack;\n  font-size: 13px;\n  color: $body-content-color;\n\n  a {\n    color: $body-content-color;\n    text-decoration: none;\n    transition: color 0.2s;\n\n    &:hover {\n      color: $develop-color;\n    }\n  }\n\n  &__separator {\n    color: $color-neutral-mid;\n  }\n}\n\n// ── Toolbar ─────────────────────────────────────────────────\n.ps-toolbar {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  margin-bottom: 28px;\n  padding: 12px 16px;\n  background: #fff;\n  border-radius: 10px;\n  border: 1px solid $color-grey-1;\n\n  @media (max-width: 767px) {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 12px;\n  }\n\n  &__filter {\n    &--search {\n      flex: 1;\n    }\n  }\n\n  &__search-wrap {\n    position: relative;\n    display: flex;\n    align-items: center;\n  }\n\n  &__search-icon {\n    position: absolute;\n    left: 12px;\n    color: $color-neutral-mid;\n    font-size: 13px;\n    pointer-events: none;\n  }\n\n  &__input {\n    width: 100%;\n    padding: 9px 36px 9px 34px;\n    border: 1px solid $color-grey-1;\n    border-radius: 6px;\n    font-size: 13px;\n    font-family: $font-stack;\n    color: $color-neutral-dark;\n    background: #f8f9fa;\n    outline: none;\n    transition: border-color 0.2s ease, box-shadow 0.2s ease;\n\n    &::placeholder { color: $color-neutral-mid; }\n\n    &:focus {\n      border-color: $develop-color;\n      box-shadow: 0 0 0 2px rgba(105, 190, 40, 0.12);\n      background: #fff;\n    }\n  }\n\n  &__clear {\n    position: absolute;\n    right: 8px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 24px;\n    height: 24px;\n    border: none;\n    background: none;\n    color: $color-neutral-mid;\n    cursor: pointer;\n    font-size: 14px;\n    border-radius: 4px;\n    transition: all 0.15s ease;\n\n    &:hover {\n      color: #b91c1c;\n      background: rgba(#b91c1c, 0.06);\n    }\n  }\n\n  &__select {\n    padding: 9px 12px;\n    border: 1px solid $color-grey-1;\n    border-radius: 6px;\n    font-size: 13px;\n    font-family: $font-stack;\n    color: $color-neutral-dark;\n    background: #f8f9fa;\n    outline: none;\n    appearance: auto;\n    cursor: pointer;\n    transition: border-color 0.2s ease;\n\n    &:focus {\n      border-color: $develop-color;\n    }\n\n    @media (max-width: 767px) {\n      width: 100%;\n    }\n  }\n\n  &__count {\n    font-size: 13px;\n    font-family: $font-stack;\n    font-weight: 600;\n    color: $body-content-color;\n    white-space: nowrap;\n\n    @media (max-width: 767px) {\n      text-align: center;\n    }\n  }\n}\n\n// ── Empty State ─────────────────────────────────────────────\n.ps-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 60px 20px;\n  text-align: center;\n\n  & > i {\n    font-size: 36px;\n    margin-bottom: 16px;\n    color: $color-neutral-mid;\n  }\n\n  p {\n    font-size: 15px;\n    color: $body-content-color;\n    margin: 0 0 16px;\n  }\n}\n\n// ── Category Sections ────────────────────────────────────────\n.ps-category {\n  margin-bottom: 40px;\n\n  &[hidden] { display: none !important; }\n\n  &__title {\n    font-family: $font-stack;\n    font-size: 24px;\n    font-weight: 700;\n    color: $color-neutral-dark;\n    margin: 0 0 20px;\n    padding-bottom: 12px;\n    border-bottom: 2px solid $color-grey-1;\n\n    &:empty {\n      display: none;\n    }\n  }\n}\n\n// ── Product Grid ─────────────────────────────────────────────\n.ps-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\n  gap: 24px;\n\n  @media (max-width: 640px) {\n    grid-template-columns: 1fr;\n    gap: 16px;\n  }\n}\n\n// ── Product Card ─────────────────────────────────────────────\n.ps-card {\n  background: #fff;\n  border-radius: 10px;\n  border: 1px solid $color-grey-1;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n\n  &[hidden] { display: none !important; }\n  transition: box-shadow 0.25s ease, transform 0.25s ease;\n\n  &:hover {\n    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);\n    transform: translateY(-3px);\n  }\n\n  // Image area\n  &__image-link {\n    display: block;\n    text-decoration: none;\n    overflow: hidden;\n  }\n\n  &__image {\n    width: 100%;\n    aspect-ratio: 4 / 5;\n    overflow: hidden;\n    background: #f8f9fa;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 12px;\n\n    img {\n      max-width: 100%;\n      max-height: 100%;\n      object-fit: contain;\n      transition: transform 0.35s ease;\n    }\n\n    &:hover img {\n      transform: scale(1.04);\n    }\n  }\n\n  // Card body\n  &__body {\n    padding: 14px 16px 16px;\n    display: flex;\n    flex-direction: column;\n    flex: 1;\n  }\n\n  // Product name\n  &__name {\n    margin-bottom: 4px;\n  }\n\n  &__name-link {\n    font-family: $font-stack;\n    font-size: 14px;\n    font-weight: 600;\n    color: $color-neutral-dark;\n    text-decoration: none;\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    line-height: 1.35;\n    transition: color 0.2s;\n\n    &:hover {\n      color: $develop-color;\n    }\n  }\n\n  // Price\n  &__price {\n    font-family: $font-stack;\n    font-size: 16px;\n    font-weight: 700;\n    color: $develop-color;\n    display: block;\n    margin-bottom: 10px;\n  }\n\n  // Actions area\n  &__actions {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    margin-top: auto;\n  }\n\n  // Quantity input\n  &__qty {\n    flex-shrink: 0;\n  }\n\n  &__qty-input {\n    width: 56px;\n    height: 32px;\n    border: 1px solid $color-grey-1;\n    border-radius: 5px;\n    padding: 2px 4px;\n    font-family: $font-stack;\n    font-size: 13px;\n    text-align: center;\n    color: $color-neutral-dark;\n    background: #fff;\n    outline: none;\n    transition: border-color 0.2s;\n\n    // Keep native spin arrows\n    &::-webkit-inner-spin-button,\n    &::-webkit-outer-spin-button {\n      opacity: 1;\n      height: 24px;\n    }\n\n    &:focus {\n      border-color: $develop-color;\n      box-shadow: 0 0 0 2px rgba(105, 190, 40, 0.12);\n    }\n  }\n\n  // Button group\n  &__btn-group {\n    display: flex;\n    gap: 6px;\n    flex-wrap: wrap;\n  }\n}\n\n// ── Buttons ──────────────────────────────────────────────────\n.ps-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 5px 12px;\n  font-family: $font-stack;\n  font-size: 12px;\n  font-weight: 600;\n  border-radius: 5px;\n  cursor: pointer;\n  text-decoration: none;\n  transition: all 0.2s ease;\n  white-space: nowrap;\n  line-height: 1.4;\n  border: 1.5px solid transparent;\n\n  &--filled-green {\n    background-color: $develop-color;\n    color: #fff;\n    border-color: $develop-color;\n\n    &:hover {\n      background-color: darken(rgba(105, 190, 40, 1), 8%);\n      border-color: darken(rgba(105, 190, 40, 1), 8%);\n      color: #fff;\n      text-decoration: none;\n    }\n  }\n\n  &--outline-green {\n    background: transparent;\n    color: $develop-color;\n    border-color: $develop-color;\n\n    &:hover {\n      background-color: $develop-color;\n      color: #fff;\n      text-decoration: none;\n    }\n  }\n\n  &--outline-cyan {\n    background: transparent;\n    color: $clarify-color;\n    border-color: $clarify-color;\n\n    &:hover {\n      background-color: $clarify-color;\n      color: #fff;\n      text-decoration: none;\n    }\n  }\n}\n\n// ── Loading State ────────────────────────────────────────────\n.ps-loader {\n  width: 100%;\n  padding: 60px 0;\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
